import React from "react";
import { DateTime } from "luxon";
import DateUtility from "./dateUtility";
/** The Film page; a film's own page is the same page with `?film=<id>`. */
export const FILM_PAGE = "/film/";
export const filmUrl = (id) => `${FILM_PAGE}?film=${id}`;
const getJson = (url, what) => fetch(url, { method: "GET" }).then((response) => response.ok ? response.json() : Promise.reject({ status: response.status, message: `Kunne ikke indlæse ${what} (${response.status} ${response.statusText})` }));
export const fetchFilms = () => getJson("/bpapi/film", "filmene");
export const fetchFilm = (id) => getJson(`/bpapi/film/${id}`, "filmen");
/** The running time as the boards write it: `1 t 57 min`, `2 t`, `45 min`; nothing when unknown. */
export const durationText = (minutes) => {
    if (!minutes || minutes <= 0)
        return "";
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    if (hours === 0)
        return `${rest} min`;
    return rest === 0 ? `${hours} t` : `${hours} t ${rest} min`;
};
export const showsText = (count) => count === 1 ? "1 forestilling" : `${count} forestillinger`;
/** When a screening is, said the short way: `I dag 19:00`, `I morgen 19:15`, `søn. 11. okt. 14:00`. */
export const whenText = (dt) => {
    const today = DateTime.local().startOf("day");
    const day = dt.startOf("day");
    const time = dt.toFormat("HH:mm");
    if (day.equals(today))
        return `I dag ${time}`;
    if (day.equals(today.plus({ days: 1 })))
        return `I morgen ${time}`;
    return `${DateUtility.rowDay(dt)} ${time}`;
};
/** The line under a film that is coming: its premiere, or when a film shown before returns. */
export const comingText = (film) => {
    const next = DateUtility.parse(film.nextShow);
    return film.isPremiere ? `Premiere ${DateUtility.rowDay(next)}` : `Vises igen ${DateUtility.rowDay(next)}`;
};
export const ClapperIcon = ({ size = 28 }) => (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
    React.createElement("path", { d: "M4 11h16v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" }),
    React.createElement("path", { d: "M4 11 3.4 7.6a1 1 0 0 1 .8-1.2l13.6-2.4a1 1 0 0 1 1.2.8L19.6 8z" }),
    React.createElement("path", { d: "m8 6.3 2.2 3.3M12.8 5.4 15 8.8" })));
export const Chevron = () => (React.createElement("svg", { className: "bi-film-chevron", width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
    React.createElement("path", { d: "m9 6 6 6-6 6" })));
/**
 * A film's poster, from `/plakat/` (cached from Integra on the server). Until it has loaded, and
 * for a film without one, the place shows a clapperboard and "Plakat" instead.
 */
export const FilmPoster = ({ id, lastWeek, className }) => (React.createElement("span", { className: `bi-film-poster${className ? ` ${className}` : ""}` },
    React.createElement("span", { className: "bi-film-poster-empty", "aria-hidden": "true" },
        React.createElement(ClapperIcon, null),
        React.createElement("span", null, "Plakat")),
    React.createElement("img", { src: `/plakat/?contentId=${id}`, alt: "", loading: "lazy", onError: (e) => { e.currentTarget.style.display = "none"; } }),
    lastWeek ? React.createElement("span", { className: "bi-film-lastweek" }, "Sidste uge") : null));
